const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  gustToken: state => state.user.gustToken,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  activeParkName: state => state.user.activeParkName,
  activeParkId: state => state.user.activeParkId
}
export default getters
